 

export default class ColorIterator {

    constructor(colors) {
        
        if(Array.isArray(colors)) {
            this.index = 0;
            this.colors = colors;
        } else if(_isFunction(colors)){
            this.next = colors;
        } else {
            throw "No valid constructor parameter. Must be either an array or a function";
        }
        
    }

    next() {
        let color = this.colors[this.index];
        this.index = (this.index < this.colors.length-1) ? this.index+1 : 0;
        return color;
    }
    
    static randomColor() {
        return '#'+Math.floor(Math.random()*16777215).toString(16);
    }

}
    
function _isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}
    
     
